import { api } from '@/api'
import type { AdminItem } from '@/api/typings/admins.typing'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface UpdateAdminPayload {
  id: number
  full_name: string
  email: string
  password?: string | null
  password_confirmation?: string | null
  roles: number // role ID
  status: 'ACTIVATE' | 'DEACTIVATE'
}

export function updateAdminAction(payload: UpdateAdminPayload): Promise<ApiResponse<AdminItem>> {
  const { id, ...rest } = payload

  return api.put<ApiResponse<AdminItem>>(`/admins/${id}`, rest)
}
